if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        this.variantIdInput.disabled = false;
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]') || this.querySelector('.product-form__submit');
        this.submitButtonText = this.submitButton.querySelector("span");
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
        this.hideErrors = this.dataset.hideErrors === "true";
        this.buyNow = this.querySelector('.shopify-payment-button__button');
        // console.log(this.buyNow)
        this.buyNow.addEventListener('click', this.handleBuyNowClick.bind(this));
        this.variantDropdown = document.querySelector('.product-form__variants');
        this.selectedVariantID = this.querySelector('.product-variant-id').value;
        this.protectionPlanPopup = document.getElementById("protection-plan-popup");
        this.protectionPlanPopupOpen = document.querySelector(".commitment-popup-btn");
        this.protectionPlanPopupClose = this.protectionPlanPopup.querySelector(".close-popup");
        this.protectionPlanPopupClose.addEventListener("click", (event) => {
          event.preventDefault();
          this.closeProtectionPlanPopup();
        });
        this.protectionPlanPopupOpen.addEventListener("click", (event) => {
          event.preventDefault();
          this.openProtectionPlanPopup();
        });
      }
      closeProtectionPlanPopup() {
        this.protectionPlanPopup.style.display = "none";
      }
      openProtectionPlanPopup() {
        this.protectionPlanPopup.querySelector('.protection-plan-wrapper').style.display = "none";
        this.protectionPlanPopup.querySelector('.lifetime-info').style.display = "none";
        this.protectionPlanPopup.querySelector('.see-details').style.display = "block";
        this.protectionPlanPopup.querySelector('.btn-wrapper').style.display = "none";
        this.protectionPlanPopup.style.display = "block";
      }
      returnCurrentVariant(){
        const SelectedOption = Array.from(this.variantDropdown.options).filter(option => option.value === this.selectedVariantID).map(option => option)[0];
        const variantQty = SelectedOption.dataset.variantQty;
        const variantPolicy = SelectedOption.dataset.inventoryPolicy;
        const variantSKU = SelectedOption.dataset.sku
        const variantRingSize = document.querySelector("#custom_ringSize") ? document.querySelector("#custom_ringSize").value : '';
        return [variantQty,variantPolicy,variantSKU,variantRingSize];
      }
      addToCartData() {
        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const timestamp = new Date().getTime();
      
        // Original form data from the product form
        const originalFormData = new FormData(this.form);
      
        // ----- 1. Extract main product info -----
        const mainVariantId = originalFormData.get("id");
        const mainQuantity = originalFormData.get("quantity") || 1;
      
        // Collect existing properties from the form: properties[Key] => { Key: value }
        const mainProperties = {};
        for (const [key, value] of originalFormData.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match) {
            mainProperties[match[1]] = value;
          }
        }
        // Preserve your current variant logic
        const [variantQty, variantPolicy, variantSKU, variantRingSize] = this.returnCurrentVariant();
        const pendent_font = document.querySelector('.font-buttons .font-btn.active')?.dataset?.fontFamily || false;
        const pendent_text_1 = document.getElementById('engrav-input-1')?.value;
        const pendent_text_2 = document.getElementById('engrav-input-2')?.value;
        console.log(pendent_font,pendent_text_1,pendent_text_2);
        if (pendent_text_1) {
          mainProperties["Pendent Text 1"] = pendent_text_1;
        }
        if (pendent_text_2) {
          mainProperties["Pendent Text 2"] = pendent_text_2;
        }
        if (pendent_font && pendent_text_1 !== 'undefined' && pendent_text_2 !== 'undefined') {
          mainProperties["Pendent Font"] = pendent_font;
        }
        if (variantRingSize.length) {
          mainProperties["Size"] = variantRingSize;
          mainProperties["_SKU with size"] = `${variantSKU}${variantRingSize}`;
        }
        if (variantPolicy === "continue" && variantQty < 1) {
          mainProperties["Shipping Time"] = "2 weeks";
        }
        mainProperties['_timestamp'] = timestamp;
        // ----- 2. Extract protection plan selection (if any) -----
        let protectionVariantId = null;
        const protectionProperties = {};
        // Find checked protection plan inside this form
        const checkedProtectionInput = document.querySelector('.protection-plan-wrapper input[name="protection_plan"]:checked');
        if (checkedProtectionInput) {
          const protectionGridItem = checkedProtectionInput.closest(".grid__item");
          const productInfoParent = document.querySelector('.product__info-container');
          if (protectionGridItem && protectionGridItem.dataset.protectionId) {
            protectionVariantId = protectionGridItem.dataset.protectionId;
            protectionProperties['_product name'] = productInfoParent.querySelector('h1').textContent;
            protectionProperties['_product price'] = productInfoParent.querySelector('.price-item--regular').textContent;
            protectionProperties['_product SKU'] = productInfoParent.querySelector('.variant-sku').textContent;
            protectionProperties['_timestamp'] = timestamp;
          }
        }

        // ----- 2. Extract matching band selection (if any) -----
        let matchingBandVariantId = null;
        const matchingBandProperties = {};
        const matchingBandCheckbox = document.querySelector('#wedding-band-checkbox');
        if (matchingBandCheckbox && matchingBandCheckbox.checked) {
          const matchingBandInput = document.querySelector('#matching-band-variant');
          matchingBandVariantId = matchingBandInput.value;
          matchingBandProperties['_timestamp'] = Date.now() + 1;
          matchingBandProperties['Size'] = variantRingSize;
        }
      
        // ----- 3. Build new FormData for /cart/add.js with multiple items[] -----
        const multiFormData = new FormData();
        // Item 0: matching band product (optional)
        if (matchingBandVariantId) {
          multiFormData.append("items[2][id]", matchingBandVariantId);
          multiFormData.append("items[2][quantity]", 1);
          Object.entries(matchingBandProperties).forEach(([propName, propValue]) => {
            console.log("items[2]-propName",propName,"propValue",propValue);
            multiFormData.append(`items[2][properties][${propName}]`, propValue);
          });
        }
        // Item 1: protection product (optional)
        if (protectionVariantId) {
          multiFormData.append("items[1][id]", protectionVariantId);
          multiFormData.append("items[1][quantity]", 1);
          Object.entries(protectionProperties).forEach(([propName, propValue]) => {
            console.log("items[1]-propName",propName,"propValue",propValue);
            multiFormData.append(`items[1][properties][${propName}]`, propValue);
          });
        }
        // Item 2: main product
        multiFormData.append("items[0][id]", mainVariantId);
        multiFormData.append("items[0][quantity]", mainQuantity);
        Object.entries(mainProperties).forEach(([propName, propValue]) => {
          multiFormData.append(`items[0][properties][${propName}]`, propValue);
        });
        // ----- 4. Preserve cart sections logic -----
        if (this.cart) {
          multiFormData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          multiFormData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
      
        config.body = multiFormData;
      
        // Optional debug:
        // console.log("Payload", Object.fromEntries(multiFormData));
      
        return [config, multiFormData];
      }
      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.submitButton.querySelector(".loading__spinner").classList.remove("hidden");
        // return false;

        const [config,formData] =  this.addToCartData();

        console.log("config",config,"formData",Object.fromEntries(config.body));

        fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          console.log(response);
          if (response.status) {
            publish(PUB_SUB_EVENTS.cartError, {
              source: "product-form",
              productVariantId: formData.get("id"),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);

            const soldOutMessage =
              this.submitButton.querySelector(".sold-out-message");
            if (!soldOutMessage) return;
            this.submitButton.setAttribute("aria-disabled", true);
            this.submitButtonText.classList.add("hidden");
            soldOutMessage.classList.remove("hidden");
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: "product-form",
              productVariantId: formData.get("id"),
              cartData: response,
            });
          this.error = false;
          this.cart.renderContents(response);
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove("loading");
          if (this.cart && this.cart.classList.contains("is-empty"))
            this.cart.classList.remove("is-empty");
          if (!this.error) this.submitButton.removeAttribute("aria-disabled");
          this.submitButton.querySelector(".loading__spinner").classList.add("hidden");
        });
      }
      handleBuyNowClick() {
        // alert('Buy Now');
        const [variantQty,variantPolicy,variantSKU,variantRingSize] = this.returnCurrentVariant();
        console.log(variantQty,variantPolicy,variantSKU,variantRingSize,routes.cart_clear_url);
        fetch(`${routes.cart_clear_url}`,{
          method: 'POST',
          headers: {
            "Content-Type": "application/json", // Set the content type
          },
        })
          .then((response) => response)
          .then((response) => {
            const [config,formData] =  this.addToCartData();
            fetch(`${routes.cart_add_url}`, config)
            .then((response) => response.json())
            .then((response) => {
              // console.log(response);
              window.location.href = '/checkout'
            })
          })
      }
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        console.log('count',disable);
        var buyNowParent = this.buyNow.closest('.shopify-payment-button');
        if (disable) {
          buyNowParent.classList.add('hidden');
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          if(theme.productTags.includes('ring-setting-product') || theme.productTags.includes('cyo-engagement-ring')){
            
          } else {
            buyNowParent.classList.remove('hidden');
            this.submitButton.removeAttribute("disabled");
            this.submitButtonText.textContent = window.variantStrings.addToCart;
          }
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}
